import {
  useQuery as useQueryApollo,
  QueryHookOptions,
  FetchPolicy
} from '@apollo/client'
import { staticLinks } from '../../../../shared/linkBuilder'
import { navigateTo } from '../util/appHistory'

// custom useQuery hook that wraps useQuery from '@apollo/client'
// can be removed when https://github.com/trojanowski/react-apollo-hooks/issues/28 is resolved
export const useThrowingQuery = <TData, TVariables = any>(
  query,
  options?: QueryHookOptions<TData, TVariables>
) => {
  const optionsWithDefaultFetchPolicy = {
    fetchPolicy: 'cache-and-network' as FetchPolicy, // TODO remove when apollo stops returning empty data from the cache here for the default fetch policy
    ...options
  }
  const { data, error, ...rest } = useQueryApollo<TData, TVariables>(
    query,
    optionsWithDefaultFetchPolicy
  )
  if (error) {
    if (error.stack?.match(/status code 401/)) {
      // seems our session is not valid anymore
      navigateTo(staticLinks.login)

      return {
        data,
        ...rest
      }
    }

    throw error // react-apollo does not throw errors by default, but we use Error boundaries extensively so we actually want it to throw
  }
  return {
    data,
    ...rest
  }
}
